import { DropdownButton, Text, Colors } from '@revenuemarket/cds';

import { RoleType } from '~apis/role/type';
import { useRoleList } from '~hooks/queries/role/query';
import { useCompanyId } from '~hooks/useCompanyId';

const RoleSelectDropdown = ({
  selectedRoleId,
  isOwner,
  onRoleChange,
}: {
  selectedRoleId: number;
  isOwner: boolean;
  onRoleChange: (roleId: string) => void;
}) => {
  const { companyId } = useCompanyId();
  const { data: roleList } = useRoleList(companyId);
  const roleListData = roleList?.Data?.data?.items || [];

  const roleItems = roleListData
    .filter((role) => {
      if (isOwner) {
        return true;
      }
      return role.type !== RoleType.SYSTEM_OWNER;
    })
    .map((role) => ({
      key: role.id.toString(),
      label: role.name,
    }));

  const selectedRole = roleListData.find((role) => role.id === selectedRoleId);

  if (!isOwner && selectedRole?.type === RoleType.SYSTEM_OWNER) {
    return (
      <Text textStyle="13_400" style={{ color: Colors.gray700, paddingLeft: 8 }}>
        {selectedRole?.name}
      </Text>
    );
  }

  return (
    <DropdownButton
      disableScroll
      buttonProps={{
        style: {
          width: 142,
          flexShrink: 0,
        },
      }}
      menu={{
        selectedKeys: selectedRoleId ? [selectedRoleId.toString()] : [],
        items: roleItems,
        onClick: (item) => onRoleChange(item.key),
      }}
      title={selectedRole?.name}
    />
  );
};

export default RoleSelectDropdown;
